import {
  GET_ALERTS_INIT,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAILED,
  Add_SINGLE_ALERT,
  GET_UNSEEN_MESSAGES_INIT,
  GET_UNSEEN_MESSAGES_SUCCESS,
  GET_UNSEEN_MESSAGES_FAILED,
  // ADD_SINGLE_MESSAGES,
  ADD_MESSAGE_ALERT,
  ADD_TOTAL_COUNT,
} from "./constants";

export const initialState = {
  loading: false,
  alertResult: {},
  totalMessages : 0,
  alertCount: 10,
  pageCount: 1,
  countAlert: 0,
};

export default function alertFactory(state = initialState, action) {
  switch (action.type) {
    case GET_ALERTS_INIT:
      return { ...state, loading: true };
    case GET_ALERTS_SUCCESS:
      let alerts;

      if (!state.alertResult.items) {
        alerts = action.payload.data;
      } else {
        action.payload.data.items = state.alertResult.items.concat(
          action.payload.data.items
        );
        alerts = action.payload.data;
      }

      return {
        ...state,
        alertResult: alerts,
        loading: false,
        alertCount: action.payload.perPage,
        pageCount: action.payload.page + 1,
        countAlert: state.countPost + 10,
      };
    case GET_ALERTS_FAILED:
      return { ...state, loading: false };
    case Add_SINGLE_ALERT:
      state.alertResult.items.push(action.alert);
      return { ...state, alertResult: state.alertResult, loading: false };
    case ADD_MESSAGE_ALERT:
      state.totalMessages = action.message.totalCount;
      return { ...state, totalMessages: state.totalMessages, loading: false };
    case ADD_TOTAL_COUNT:
      state.totalMessages = action.total.totalCount;
      return { ...state, totalMessages: state.totalMessages, loading: false };
    case GET_UNSEEN_MESSAGES_INIT:
      return { ...state, loading: true };
    case GET_UNSEEN_MESSAGES_SUCCESS:
      return {
        ...state,
        totalMessages: action.payload,
        loading: false,
      };
    case GET_UNSEEN_MESSAGES_FAILED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
